<template>
  <v-breadcrumbs ref="breadcrumbs">
    <v-icon slot="divider">chevron_right</v-icon>
    <v-breadcrumbs-item
        v-for="(nav, index) in computedNav"
        :key="index"
        :to="nav.link"
        :class="['path', nav.length && nav.length > 0 ? 'not-blocking' : (nav.hasOwnProperty('link') && !nav.link) ? 'disabled-item' : '',]"
        :exact="true"
        @click.native="analytics(nav.link)">
      <li v-if="nav.length && nav.length > 0" class="hidden-crumbs pa-0">
        <v-menu offset-y class="path pa-0">
            <v-icon slot="activator" right style="color: #4A4A4A; pointer-events: none;">more_horiz</v-icon>
          <v-list>
            <v-list-tile v-for="(nav, index) in nav" :key="index" @click="clickBreadcrumb(nav.link)">
              <format-badge
                :icon="nav.icon || ''"
                :type="nav.type || ''"
                :color="nav.color || ''"
                :extension="nav.extension || ''"
                :avatar="nav.avatar || ''"
                :name="nav.name || ''"
              ></format-badge>
              <v-list-tile-content>
                <v-list-tile-title>{{nav.translate ? $tf(nav.translate) : nav.name}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </li>
      <div v-else>
        <format-badge
            :icon="nav.icon || ''"
            :type="nav.type || ''"
            :color="nav.color || ''"
            :extension="nav.extension || ''"
            :avatar="nav.avatar || ''"
            :name="nav.name || ''"/>
        <span
          class="breadcrumb--title">{{nav.translate ? $tf(nav.translate) : nav.name}}</span>
      </div>
    </v-breadcrumbs-item>
  </v-breadcrumbs>
</template>

<script>
  import FormatBadge from '~/components/common/files/FormatBadge.vue'
  import bus from '~/bus'

  export default {
    name: 'idonia-breadcrumbs',
    components: {FormatBadge},
    data () {
      return {
        ro: null,
        overflown: 0
      }
    },
    computed: {
      storedNav () {
        let nav = []
        if (this.$store.state.nav.navRoot && !this.$store.getters['viewport/embed']) {
          nav.push(this.$store.state.nav.navRoot)
        }
        if (this.$store.state.nav.navPath && this.$store.state.nav.navPath.length > 0) {
          nav.push(...this.$store.state.nav.navPath)
        }
        if (this.$store.state.nav.navCurrent) {
          nav.push(this.$store.state.nav.navCurrent)
        }

        return nav
      },
      computedNav () {
        let collapsed = 0
        let items = []
        for (let i = 0; i < this.storedNav.length; i++) {
          if (!this.storedNav[i] || Object.keys(this.storedNav[i]).length === 0) {
            continue
          }
          if (i === 0) {
            items.push(this.storedNav[i])
            continue
          }
          if (i === 1 && this.overflown > 0) {
            items.push([])
          }
          if (collapsed < this.overflown) {
            items[1].push(this.storedNav[i])
            collapsed++
            continue
          }
          items.push(this.storedNav[i])
        }

        return items
      }
    },
    mounted () {
      if (window.ResizeObserver) {
        this.ro = new window.ResizeObserver(this.debounce(100, this.reset))
        this.ro.observe(this.$refs.breadcrumbs.$el)
        this.ro.observe(this.$refs.breadcrumbs.$root.$el)
      } else {
        // TODO
        console.log('no resizeobserver')
      }
    },
    beforeUnmount () {
      this.ro.unobserve(this.$refs.breadcrumbs.$el)
      this.ro.unobserve(this.$refs.breadcrumbs.$root.$el)
    },
    methods: {
      debounce (ms, fn) {
        let timer
        return function () {
          clearTimeout(timer)
          let args = Array.prototype.slice.call(arguments)
          args.unshift(this)
          timer = setTimeout(fn.bind.apply(fn, args), ms)
        }
      },
      collapse () {
        if (!this.$refs.breadcrumbs) {
          return
        }
        if (this.$refs.breadcrumbs.$el.scrollWidth > this.$refs.breadcrumbs.$el.clientWidth) {
          this.overflown++
          if (this.overflown < this.storedNav.length) {
            this.$nextTick(() => {
              this.collapse()
            })
          }
        }
      },
      reset () {
        this.overflown = 0
        this.$nextTick(() => {
          this.collapse()
        })
      },
      clickBreadcrumb (link) {
        this.$router.push(link)
        this.analytics(link)
      },
      analytics (link) {
        if (link) {
          bus.$emit('analytics', {
            action: 'breadcrumbs-clicked',
            arguments: {
              file_id: link.split('/').pop(),
              route: link
            }
          })
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .breadcrumbs {
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
    margin-left: 5px;
    justify-content: flex-start;
    align-self: center;
    padding: 0 !important;

    & /deep/ li {
      &.hidden-crumbs .btn {
        &--icon,
        &__content,
        &__content:before {
          border-radius: 0px;
        }

        width: 64px;

        .icon {
          margin-right: 16px;
          &:last-child {
            margin-left: 0px;
            color: rgba(0, 0, 0, 0.54);
            font-size: 16px;
          }
        }
      }

      .breadcrumbs__item {
        -ms-flex-align: center;
        align-items: center;
        color: var(--primary_text);
        display: -ms-inline-flexbox;
        display: inline-flex;
        font-size: 14px;
        padding: 0 0;
        height: 40px;
        text-decoration: none;
        text-decoration-line: none;
        text-decoration-style: initial;
        text-decoration-color: initial;
        line-height: 40px;
        // transition: .3s cubic-bezier(.25, .8, .25, 1);
        div {
          display: flex;
          padding: 0 16px;
        }
        .icon {
          font-size: 24px;
          user-select:none;
          -moz-user-select:none;
          -webkit-user-select:none;
          -ms-user-select:none;
        }
      }

      &:not(:last-child) .breadcrumbs__item {
        .icon,
        .breadcrumb--title {
          white-space: pre;
          color: #4a4a4a;
        }
      }

      &:last-child {
        &.breadcrumbs__divider {
          display: none;
        }

        .breadcrumbs__item {
          .icon,
          .breadcrumb--title {
            white-space: nowrap;
            color: var(--primary_text);
          }
        }
      }

    }


  }

  /deep/ .breadcrumbs__divider {
    padding: 0 4px !important;
  }

  /deep/ .breadcrumbs__divider i {
    color: #4a4a4a;
  }

  .breadcrumbs li {
    display: flex;
    border-radius: 6px;
    // transition: all 0.3s cubic-bezier(.25, .8, .25, 1) !important;
  }

  .list__tile__title,
  .list__tile__sub-title {
    margin-left: 15px !important;
  }

  div.path {
    display: flex !important;
    padding: 0 2px 2px 5px;
    vertical-align: middle;
  }

  div.path i {
    vertical-align: middle;
  }

  .breadcrumbs .menu {
    border-radius: 6px;
    margin-right: 0;
    vertical-align: middle;
  }

  .breadcrumbs .menu__activator .icon {
    width: 25px;
    color: #bdbdbd;
    vertical-align: middle;
    box-sizing: border-box;
    display: block;
    font-size: 25px;
  }

  .breadcrumbs .menu__activator--active .icon:last-child {
    transform: rotate(90deg);
  }

  .breadcrumbs li:hover {
    background-color: #ECECEC;
    // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24) !important;
  }

  .breadcrumbs li:not(.not-blocking):last-child:hover {
    background-color: initial !important;
    box-shadow: none !important;
  }

  .breadcrumbs .disabled-item /deep/ a {
    cursor: default !important;
    pointer-events: none !important;
  }

  .breadcrumbs li.disabled-item:hover {
    background-color: initial !important;
    box-shadow: none !important;
  }

  .breadcrumbs li::after {
    font-size: 25px;
    color: black;
    vertical-align: baseline !important;
  }

  .breadcrumbs li div .format-badge {
    padding: 0 !important;
    margin-right: 10px;
    align-items: center;
  }

  .list__tile__sub-title {
    max-width: 350px;
    text-overflow: ellipsis;
  }

  .idonia-header .breadcrumbs li a,
  .idonia-header .breadcrumbs .list__tile__title {
    color: #4a4a4a;
  }

  .idonia-header .breadcrumbs .menu__activator {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .idonia-header .breadcrumbs li:last-child a {
    color: var(--primary_text);
  }

  .breadcrumbs li span {
    max-height: 40px;
  }

  .breadcrumbs .not-blocking /deep/ a{
    cursor: pointer;
    pointer-events: all;
  }

  @media only screen and (max-width: 600px) {
    .breadcrumbs__item div {
      padding: 0 !important;
    }
  }
  
</style>
<style lang="scss">
  @media only screen and (max-width: 600px) {
    .breadcrumbs {
      margin-left: 24px !important;
    }
    .breadcrumbs__item .icon {
      font-size: 16px !important;
      width: 20px !important;
      height: 20px !important;
      padding: 12px !important;
    }
    .breadcrumbs__item .menu__activator {
      padding-left: 0 !important;
      margin: 0 -5px !important;
      .icon {
        height: 40px !important;
      }
      &.menu__activator--active {
        margin-top: -15px !important;
      }
    }
    .format-badge {
      margin-right: 5px !important;
    }
    .breadcrumbs li:first-child:not(:last-child) {
      .breadcrumb--title {
        display: none;
      }
      .format-badge {
        margin-right: -5px !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/Breadcrumbs.vue